export const projectTopicOption = [
    'Brand Guidance',
    'Brand Strategy',
    'Creative',
    'Customer Experience',
    'Innovation',
    'Media',
    'Other'
]
